var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"action-to-plan-creditcard",attrs:{"to":_vm.path}},[_vm._v("\n  お支払い方法を変更する\n")])}
var staticRenderFns = []

export { render, staticRenderFns }